export const rootElementId = 'accountRecoveryModal-container';

export const translation = {
  common: ['CommonUI.Controls'],
  feature: 'Authentication.ResetPassword'
};
